import React from 'react';

export default class Banner extends React.Component {
    render() {
        return <section className="top-banner yellow-bg">
            {this.props.imgSrc ? <img className="banner-img" src={this.props.imgSrc} /> : null}
            <div className="row">
                <div className="col-md-8">
                    {this.props.children}
                </div>
            </div>
        </section>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Banner.js